module.exports = __webpack_public_path__ + "static/media/ahi-pi-no-data.41563b36.svg";